import script from "./image.vue?vue&type=script&setup=true&lang=ts"
export * from "./image.vue?vue&type=script&setup=true&lang=ts"

import "./image.vue?vue&type=style&index=0&id=43fa69a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43fa69a6"]])

export default __exports__